import SimpleData from "../../class/SimpleData.js";
import isEqual from "lodash.isequal";
import { log, handleMissingKeys, getUniqueKeys, round, } from "../../exports/helpers.js";
export default function addItems(data, dataToBeAdded, fillMissingKeys, defaultValue, verbose) {
    if (dataToBeAdded instanceof SimpleData) {
        dataToBeAdded = dataToBeAdded.getData();
    }
    let newData = data.concat(dataToBeAdded);
    const uniqueKeys = getUniqueKeys(data);
    const uniqueKeysToBeAdded = getUniqueKeys(dataToBeAdded);
    if (!fillMissingKeys &&
        !isEqual(uniqueKeys, uniqueKeysToBeAdded) &&
        data.length > 0) {
        throw new Error(`data and dataToBeAdded don't have the same keys\ndata keys => ${String(uniqueKeys)}\ndataToBeAdded keys => ${String(uniqueKeysToBeAdded)}`);
    }
    const uniqueKeysCombined = [
        ...new Set([...uniqueKeys, ...uniqueKeysToBeAdded]),
    ].sort();
    newData = handleMissingKeys(newData, true, defaultValue, uniqueKeysCombined);
    verbose &&
        log(`/!\\ ${newData.length - data.length} items added. Number of items increased by ${round(((newData.length - data.length) / data.length) * 100, 1)}%`, "bgRed");
    return newData;
}
//# sourceMappingURL=addItems.js.map